function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThe217LogoTransparent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 680 180",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    },
    id: titleId
  }, "217 \u2014 UIAA Staff Portal logo") : title ? /*#__PURE__*/React.createElement("title", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    },
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("desc", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "\n    Logo with simplified Hallene Gateway column outline next to 217 wordmark, transparent background\n  "), /*#__PURE__*/React.createElement("g", {
    transform: "translate(112, 18)",
    fill: "none",
    stroke: "#FF5F05",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      fill: "none",
      stroke: "rgb(255, 95, 5)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "2.5px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 112,
    height: 10,
    rx: 1,
    style: {
      fill: "none",
      stroke: "rgb(255, 95, 5)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "2.5px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 10,
    width: 100,
    height: 6,
    rx: 1,
    style: {
      fill: "none",
      stroke: "rgb(255, 95, 5)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "2.5px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 16,
    width: 10,
    height: 88,
    rx: 1,
    style: {
      fill: "none",
      stroke: "rgb(255, 95, 5)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "2.5px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 14,
    width: 14,
    height: 5,
    rx: 1,
    style: {
      fill: "none",
      stroke: "rgb(255, 95, 5)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "2.5px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 104,
    width: 14,
    height: 5,
    rx: 1,
    style: {
      fill: "none",
      stroke: "rgb(255, 95, 5)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "2.5px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 16,
    width: 10,
    height: 88,
    rx: 1,
    style: {
      fill: "none",
      stroke: "rgb(255, 95, 5)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "2.5px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 14,
    width: 14,
    height: 5,
    rx: 1,
    style: {
      fill: "none",
      stroke: "rgb(255, 95, 5)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "2.5px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 104,
    width: 14,
    height: 5,
    rx: 1,
    style: {
      fill: "none",
      stroke: "rgb(255, 95, 5)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "2.5px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 16,
    width: 10,
    height: 88,
    rx: 1,
    style: {
      fill: "none",
      stroke: "rgb(255, 95, 5)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "2.5px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 14,
    width: 14,
    height: 5,
    rx: 1,
    style: {
      fill: "none",
      stroke: "rgb(255, 95, 5)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "2.5px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 104,
    width: 14,
    height: 5,
    rx: 1,
    style: {
      fill: "none",
      stroke: "rgb(255, 95, 5)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "2.5px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 16,
    width: 10,
    height: 88,
    rx: 1,
    style: {
      fill: "none",
      stroke: "rgb(255, 95, 5)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "2.5px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 14,
    width: 14,
    height: 5,
    rx: 1,
    style: {
      fill: "none",
      stroke: "rgb(255, 95, 5)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "2.5px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 104,
    width: 14,
    height: 5,
    rx: 1,
    style: {
      fill: "none",
      stroke: "rgb(255, 95, 5)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "2.5px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,104 L36,52 Q36,16 56,16 Q76,16 76,52 L76,104",
    style: {
      fill: "none",
      stroke: "rgb(255, 95, 5)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "2.5px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 109,
    width: 112,
    height: 7,
    rx: 1,
    style: {
      fill: "none",
      stroke: "rgb(255, 95, 5)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "2.5px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: -4,
    y: 116,
    width: 120,
    height: 5,
    rx: 1,
    style: {
      fill: "none",
      stroke: "rgb(255, 95, 5)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "2.5px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  })), /*#__PURE__*/React.createElement("text", {
    x: 270,
    y: 40,
    fontFamily: "Arial, sans-serif",
    fontSize: 10,
    fontWeight: 400,
    fill: "rgba(255,255,255,0.35)",
    letterSpacing: 3.5,
    style: {
      fill: "rgba(255, 255, 255, 0.35)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "Arial, sans-serif",
      fontSize: 20,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "THE"), /*#__PURE__*/React.createElement("text", {
    x: 268,
    y: 115,
    fontFamily: "Arial Black, Arial, sans-serif",
    fontSize: 80,
    fontWeight: 900,
    fill: "white",
    letterSpacing: -2,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 80,
      fontWeight: 900,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "217"));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThe217LogoTransparent);
export default __webpack_public_path__ + "static/media/the217_logo_transparent.d0c6aa5e55ba714d1867ce534169315f.svg";
export { ForwardRef as ReactComponent };